<script>
import { mapActions } from 'vuex';
import NotificationCount from '../../../components/NotificationCount.vue';

export default {
    components: {
        NotificationCount
    },

    data() {
        return {
            notifications: [],
            showUnread: true,

            requestInterval: null,
        }
    },

    computed: {
        filtered_notifications() {
            if (this.showUnread == false) {
                return this.notifications.filter(i => i.is_deleted == true);
            } else {
                const data = this.notifications.filter(i => i.is_deleted == false);
                return data;
            }
        },
    },

    async mounted() {
        await this._getSustainfinityLinks();
        this.requestInterval = setInterval(async () => {
            await this._getSustainfinityLinks();
        }, 10000);
    },

    beforeDestroy() {
        clearInterval(this.requestInterval);
    },

    methods: {
        ...mapActions("company", [
            "getSustainfinityLinks",
            "acceptSustainfinityLink",
            "declineSustainfinityLink",
            "blockCompany"
        ]),

        async _getSustainfinityLinks() {
            this.notifications = [];

            await this.getSustainfinityLinks()
                .then( (res) => {
                    for (let index = 0; index < res.data.sustainfinity_links.length; index++) {
                        const element = res.data.sustainfinity_links[index];
                        let obj = {
                            sustainfinity_link_id: element.sustainfinity_link_id,
                            is_deleted: element.is_deleted,
                            msg: ""
                        };

                        // asdasdasd
                        const lang = localStorage.getItem("lang");
                        if (this.$user.company_id == element.primary_company_id) {

                            if (lang.toLowerCase().includes("en")) {
                                obj.msg = `Company <span style="font-weight: bold !important; color: var(--sustainfinity-blue)">${element.supplier_company_name}</span> 
                                    has asked you to link to them as a 
                                    <span style="font-weight: bold !important; color: var(--sustainfinity-blue)">customer</span>.
                                    <span style="color: gray; font-style: italic; font-size: .8em">${this.dateFormat(element.created_on)}</span>
                                `;
                            } else if (lang.toLowerCase().includes("tr")) {
                                obj.msg = `<span style="font-weight: bold !important; color: var(--sustainfinity-blue)">${element.supplier_company_name}</span> 
                                    firması size bir
                                    <span style="font-weight: bold !important; color: var(--sustainfinity-blue)">tedarikçi</span>
                                    olarak bağlanmayı talep etti.
                                    <span style="color: gray; font-style: italic; font-size: .8em">${this.dateFormat(element.created_on)}</span>
                                `;
                            }
                            obj.sender_company_id = element.supplier_company_id;
                        } else if (this.$user.company_id == element.supplier_company_id) {
                            if (lang.toLowerCase().includes("en")) {
                                obj.msg = `Company <span style="font-weight: bold !important; color: var(--sustainfinity-blue)">${element.primary_company_name}</span> 
                                    has asked you to link to them as a 
                                    <span style="font-weight: bold !important; color: var(--sustainfinity-blue)">supplier</span>.
                                    <span style="color: gray; font-style: italic; font-size: .8em">${this.dateFormat(element.created_on)}</span>
                                `;
                            } else if (lang.toLowerCase().includes("tr")) {
                                obj.msg = `<span style="font-weight: bold !important; color: var(--sustainfinity-blue)">${element.primary_company_name}</span> 
                                    firması size bir
                                    <span style="font-weight: bold !important; color: var(--sustainfinity-blue)">müşteri</span>
                                    olarak bağlanmayı talep etti.
                                    <span style="color: gray; font-style: italic; font-size: .8em">${this.dateFormat(element.created_on)}</span>
                                `;
                            }
                            obj.sender_company_id = element.primary_company_id;
                        }

                        this.notifications.push(obj);
                    }
                })
                .catch(({ response }) => {
                    console.error(this.$parseResMessage(response.messageName));
                })
        },

        async _acceptSustainfinityLink(item) {
            const params = {
                sustainfinity_link_id: item.sustainfinity_link_id,
                created_by: this.$user.user_id
            };

            this.acceptSustainfinityLink(params)
                .then( res => {
                    this.$notify('success', res.data.messageName);
                })
                .catch(({ response }) => {
                    this.$notify('error', response.data.messageName);
                })
                .finally(async () => {
                    await this._getSustainfinityLinks();
                    this.$emit('count', -1);
                })
        },

        async _declineSustainfinityLink(item) {
            const params = {
                sustainfinity_link_id: item.sustainfinity_link_id,
                deleted_by: this.$user.user_id
            };

            this.declineSustainfinityLink(params)
                .then( res => {
                    this.$notify('success', res.data.messageName);
                })
                .catch(({ response }) => {
                    this.$notify('error', response.data.messageName);
                })
                .finally(async () => {
                    await this._getSustainfinityLinks();
                    this.$emit('count', -1);
                })
        },

        async _blockCompany(item) {
            const params = {
                blocked_company_id: item.sender_company_id,
                company_id: this.$user.company_id,
                deleted_by: this.$user.user_id,
                sustainfinity_link_id: item.sustainfinity_link_id
            };

            this.blockCompany(params)
                .then( res => {
                    this.$notify('success', res.data.messageName);
                })
                .catch(({ response }) => {
                    this.$notify('error', response.data.messageName);
                })
                .finally(async () => {
                    await this._getSustainfinityLinks();
                    this.$emit('count', -1);
                })
        },

        
        // handlers //

        handleClickShowUnread(bool) {
            this.showUnread = bool;
        },

        // emitter //
        
        dateFormat(value) {
            if (!value) return "N/A";
            let current_datetime = new Date(value);
            return (
                current_datetime.getDate() +
                "/" +
                (current_datetime.getMonth() + 1) +
                "/" +
                current_datetime.getFullYear() +
                " - " +
                current_datetime.getHours() +
                ":" +
                (current_datetime.getMinutes() < 10 ? "0" : "") +
                current_datetime.getMinutes()
            );
        }
    }
}
</script>

<template>
    <Transition name="fade">
        <div class="notifications-container">
            <div class="show-unread-ctr">
                <div class="show-unread-only-btn" :class="{ 'selected-btn': showUnread }"
                    @click="handleClickShowUnread(true)">
                    {{ $t('notifications.show_unread_only') }}
                </div>
                <div class="show-all-btn" :class="{ 'selected-btn': !showUnread }" @click="handleClickShowUnread(false)">
                    {{ $t('notifications.show_past') }}
                </div>
            </div>
            <div v-for="item in filtered_notifications" :key="item.val" 
                class="notification"
                :style="{ 'pointer-events': !showUnread ? 'none' : null }"
            >
                <div class="notification-text" 
                    v-html="item.msg" 
                    :class="{ 'marked-read-message': !showUnread }"
                ></div>
                <div class="notification-interact-btns-ctr" v-if="showUnread">
                    <i @click="_blockCompany(item)" v-b-tooltip.hover="{ title: $t('notifications.block_company') }"
                        class="block-btn fa-solid fa-ban"></i>
                    <i @click="_declineSustainfinityLink(item)" v-b-tooltip.hover="{ title: $t('notifications.delete') }"
                        class="delete-btn fa-solid fa-circle-xmark"></i>
                    <i @click="_acceptSustainfinityLink(item)"
                        v-b-tooltip.hover="{ title: $t('notifications.accept_invitation') }"
                        class="accept-btn fa-solid fa-circle-check"></i>
                </div>
            </div>

            <div class="no-notifications-text" v-if="filtered_notifications.length == 0">
                {{ $t('notifications.nothing') }}
            </div>
        </div>
    </Transition>
</template>

<style lang='scss' scoped>
    .fade-active {
        transition: opacity .66s ease;
    }

    .fade-from,
    .fade-to {
        opacity: 1;
    }

    .notifications-container {
        background-color: whitesmoke;
        border-radius: .5em;
        border: thin solid var(--sustainfinity-navy);

        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-content: flex-start;
        align-items: flex-start;

        width: 400px;
        max-height: 400px;
        overflow-y: auto;
        overflow-x: hidden;

        > .notification {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-content: center;
            align-items: center;

            padding: .5em;
            width: 100%;
            border-bottom: thin solid lightgray;
            color: black;

            transition: all 150ms;
            cursor: pointer;
            &:hover {
                background-color: lightgray;
            }

            > .notification-text {
                flex: .65;
            }

            > .marked-read-message {
                flex: 1 !important;
                pointer-events: none !important;
                cursor: default !important;
            }

            > .notification-interact-btns-ctr {
                flex: .35;
                display: flex;
                flex-direction: row;
                justify-content: space-around;
                align-content: center;
                align-items: center;
                border-left: thin solid gray;

                > i {
                    color: black;
                    transition: all 100ms;
                }

                > .accept-btn:hover {
                    color: var(--sustainfinity-green);
                }

                > .delete-btn:hover {
                    color: var(--invalid-input);
                }

                > .block-btn:hover {
                    color: rgb(140, 0, 0);
                }
            }
        }

        > .show-unread-ctr {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-content: center;
            align-items: center;
            width: 100%;
            border-bottom: thin solid lightgray;

            > div {
                text-align: center;
                flex: .5;
                transition: all 150ms;
                cursor: pointer;
                &:hover {
                    background-color: lightgray;
                }
            }

            > .show-unread-only-btn {
                border-right: thin solid lightgray;
            }

            > .selected-btn {
                background-color: gray;
                color: white;
            }
        }

        > .no-notifications-text {
            padding: 1em;
        }
    }

</style>